import { darkComponentColors } from "./componentColors";

export const lemmonDark = {
  lemmonDark: {
    "color-scheme": "dark",
    primary: "#047aff",

    "primary-content": "#ead9ff",

    secondary: "#101923",

    "secondary-content": "#fff",

    accent: "#fff",

    "accent-content": "#000",

    neutral: "#5c6e82",

    "neutral-content": "#fff",

    "base-100": "#1d232a",

    "base-200": "#191e24",
    "base-300": "#15191e",
    "base-content": "#a6adbb",
    "--font-family": '"Inter", system-ui, sans-serif',
    "--form-control-background": "#15191e",
    "--lemmon-switcher-background": "rgba(255, 255, 255, 0.06)",
    "--lemmon-switcher-border": "rgba(255, 255, 255, 0.08)",
    "--lemmon-switcher-indicator-background": "rgba(255, 255, 255, 0.12)",
    "--lemmon-switcher-indicator-overlay-background":
      "rgba(255, 255, 255, 0.12)",
    "--lemmon-switcher-indicator-shadow": "rgba(0, 0, 0, 0.3) 0px 1px 3px",

    info: "#0099e3",

    "info-content": "#000812",

    success: "#11B981",

    "success-content": "#031202",

    warning: "#f4bf50",

    "warning-content": "#000",

    error: "#CA2625",

    "error-content": "#fff",

    "--pos-card-bg": "#394758",
    "--pos-card-selected-bg": "#191e24",
    "--pos-bar-color": "#ffffff",
    "--body-bg-color": "#1d232a",
    "--pos-panel-bg": "#273442",
    "--pos-border-color": "#374151",
    "--pos-shadow-color": "#0000004d",
    "--pos-shadow-highlight": "#fff3",
    ...darkComponentColors,
  },
};
